import React, { Component } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PeopleCard from "../../../components/PeopleCard";

import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import AuthService from "../../../session/AuthService";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";



class PeoplesCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendedFriendsList: [],
      recommendedFriendsListState: false,
    };
    this.getRecommendedFriendsList = this.getRecommendedFriendsList.bind(this);
    this.requestSentPage = this.requestSentPage.bind(this);
    this.gotoSuggestedFriendsList = this.gotoSuggestedFriendsList.bind(this);
    this.ignoreSentPage = this.ignoreSentPage.bind(this);
  }

  componentDidMount() {
    this.getRecommendedFriendsList(
      this.props.recommended_friends_list,
      this.props.recommendedListLength
    );
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.recommended_friends_list !== this.props.recommended_friends_list
    ) {
      this.getRecommendedFriendsList(
        this.props.recommended_friends_list,
        this.props.recommendedListLength
      );
    }
  }

  render() {

    return (
      <div className="peopleCarouselWrapper ">
        <div className="searchHeading flexDefault flexAlignCenter flexJustifySpacebetween">
        </div>


        <Grid container spacing={2}>
          {!this.state.recommendedFriendsListState &&
            this.state.recommendedFriendsList.map((people, index) => {
              return (
                <Grid item xs={12} sm={12} md={3} lg={3} key={index}>
                  <React.Fragment key={index}>
                    <PeopleCard
                      userId={people.uId}
                      name={`${people.fName} ${people.lName}`}
                      Dname={people.dName}
                      userName={people.userName}
                      country={
                        people.countryName !== null
                          ? people.countryName
                          : "--------"
                      }
                      nameLocation={
                        people.location != null ? people.location : "--------"
                      }
                      profession={
                        people.professionName != null
                          ? people.professionName
                          : "--------"
                      }
                      //   subjects={people.user.userLearn}
                      tagsValue={
                        people.tagsValue.length !== 0
                          ? people.tagsValue
                          : "---------"
                      }
                      requestSent={this.requestSentPage}
                      ignoreSent={this.ignoreSentPage}
                      searchData={this.props.searchData}
                      coverPhoto={people.coverPhoto}
                      profilePhoto={people.profilePhoto}
                      premiumData={people?.premiumData}
                    />
                  </React.Fragment>
                </Grid>
              );
            })}
        </Grid>
        {/* </Slider>   */}
        {/* </Grid> */}
      </div>
    );
  }

  ignoreSentPage() {
    this.props.ignoreSentPageData();
  }

  requestSentPage(e) {
    // alert(e)
    this.props.requestSentPageData(e, "recommend");
  }

  async getRecommendedFriendsList(
    recommended_friends_list,
    recommendedListLength
  ) {
    if (recommended_friends_list.length > 0) {
      await this.setState({
        recommendedFriendsList: recommended_friends_list,
        recommendedFriendsListState: false,
        recommendedListLengths: recommendedListLength,
      });
    } else {
      await this.setState({
        recommendedFriendsListState: true,
        recommendedListLengths: recommendedListLength,
      });
    }
  }

  gotoSuggestedFriendsList() {
    this.props.history.push({
      pathname: "/suggested-friends-list",
    });
  }
}

export default withTranslation()(withRouter(PeoplesCarousel));
